// extracted by mini-css-extract-plugin
export default {"cls1":"ResultsList-Error_cls1__fZ82g","cls2":"ResultsList-Error_cls2__zNQKR ResultsList-Error_cls1__fZ82g"};